// extracted by mini-css-extract-plugin
module.exports = {"title":"xlsUk","open":"e5nYQ","collapse":"eR9NS"};